<!-- src/app/user-avatar/user-avatar.component.html -->
<div class="flex items-center space-x-2">
    <ng-container *ngIf="photo; else noPhoto">
      <img
        class="w-8 h-8 rounded-full object-cover"
        [src]="photo"
        alt="User Photo"
      />
    </ng-container>
    <ng-template #noPhoto>
      <span class="w-8 h-8 rounded-full bg-teal-700 flex items-center justify-center text-white font-bold">
        {{ getInitials(userName) }}
      </span>
    </ng-template>
    <span *ngIf="displayUserName" class="ml-2 font-bold text-gray-800">{{ userName || 'Unknown User' }}</span>
  </div>
  